import React from 'react';
import './UIInputWithLabel.scss';

export interface UIInputWithLabelProps {
  /**
   * Лейбл (обов'язковий)
   */
  label: string;

  /**
   * Ширина лейбла в відсотках
   */
  labelWidth?: number;

  /**
   * Значення інпута
   */
  value?: string;

  /**
   * Обробник зміни значення
   */
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;

  /**
   * Плейсхолдер
   */
  placeholder?: string;

  /**
   * Додатковий CSS клас
   */
  className?: string;

  /**
   * Інші властивості input
   */
  [key: string]: any;
}

const UIInputWithLabel: React.FC<UIInputWithLabelProps> = ({
                                                             label,
                                                             labelWidth,
                                                             value,
                                                             onChange,
                                                             placeholder,
                                                             className = '',
                                                             ...props
                                                           }) => {
  const renderLabel = () => {
    const parts = label.split('*');
    return parts.map((part, index) => (
      <React.Fragment key={index}>
        {part}
        {index < parts.length - 1 && <span className="UIInputWithLabel__asterisk">*</span>}
      </React.Fragment>
    ));
  };

  const labelStyle = labelWidth ? { flexBasis: `${labelWidth}%` } : {};

  return (
    <div className={`UIInputWithLabel ${className}`}>
      <label className="UIInputWithLabel__label" style={labelStyle}>
        {renderLabel()}
      </label>

      <input
        className="UIInputWithLabel__input"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        {...props}
      />
    </div>
  );
};

export default UIInputWithLabel;
